import $ from 'jquery';
window.addEventListener('px-ready',function(){
    $('.px-maincontent blockquote').wrap('<div class="blockquote-container"><div class="uk-container uk-container-small"></div></div>')
})